import { SkipLinksUI } from "./SkipLinksUI";
import { StandardProps } from "../componentMap";
import { ensureIsActive } from "../../utils/product/ensureIsActive";
import { hasAnyStock } from "../../utils/product/hasAnyStock";
import { useVariant } from "../../hooks/useVariant/useVariant";
import { isInStoreOnly } from "../../utils/variant/isInStoreOnly";

export const SkipLinks = ({
  product,
  flags,
}: Pick<StandardProps, "product" | "flags">) => {
  const { variant } = useVariant(product);
  const showSkipLinks = flags?.showSkipLinks.value;
  const enablePremiumRhrSideDrawers = flags?.enablePremiumRhrSideDrawers.value;

  if (
    ensureIsActive(product) &&
    !hasAnyStock(product) &&
    product.variants.length === 1 &&
    !isInStoreOnly(variant)
  ) {
    return null;
  }
  if (!showSkipLinks) return null;
  if (enablePremiumRhrSideDrawers === "rhr") return null;

  return (
    <SkipLinksUI
      productType={product.__typename}
      isActive={!!ensureIsActive(product)}
      isInStoreOnly={isInStoreOnly(variant)}
    />
  );
};
